import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteDocument } from '../services/api/documents';

export const useDocumentDelete = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deleteDocument(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['documents'] });
    },
  });
};
